const messages = {
  seasons: {
    all: "Quattro stagioni",
    summer: "Estivi",
    winter: "Invernali",
    general: "Generale",
  },
  offer:
    "Ampliamo regolarmente le nostre offerte per te!<br /><br />Ti informeremo sulle nuove formazioni nella tua casella di posta.",
  summary: {
    congratulations: "COMPLIMENTI - HAI COMPLETATO LA TUA FORMAZIONE SU",
    participation:
      "Hai completato con successo la formazione online Transporter All-Season Tires.",
    certificate:
      "Il certificato ti sarà inviato via email oppure puoi scaricarlo direttamente in PDF qui:",
    send: "Scarica il certificato",
  },
  online: {
    title: "Le nostre formazioni online",
    desc: "Ottieni conoscenze specialistiche e, al superamento dei test, ricevi il tuo certificato personale di partecipazione e un bonus iniziale di 40 punti per il club premium.",
    content:
      "Scopri ora le nostre formazioni online e partecipa subito qui sulla piattaforma:",
    categories: {
      title: "Formazione online",
      description:
        "Resta al passo con il sapere: ottieni un know-how esclusivo per te e il tuo team con le nostre offerte formative. Che si tratti delle sessioni online a cui partecipare direttamente sulla piattaforma, dei corsi e seminari pratici al Bridgestone Training Center o di formazioni esterne i cui costi puoi ridurre con i tuoi punti premium.",
      general: {
        title: "Generale",
        subtitle: "Formazione online: Generale",
        description:
          "Scopri le ultime tecnologie, gli sviluppi più importanti del settore pneumatici, consigli per le tue argomentazioni di vendita e altro ancora.",
        subdesription:
          "Ottieni conoscenze specialistiche e, dopo aver superato i test, il tuo certificato personale di partecipazione insieme a un bonus una tantum di 40 punti per il club premium.",
      },
      product: {
        title: "Prodotti",
        subtitle: "Formazione online: Prodotti",
        description:
          "Approfondisci la tua competenza sui prodotti Bridgestone e Firestone per vendite di successo con i nostri video formativi compatti.",
        subdesription:
          "Ottieni conoscenze specialistiche e, dopo aver superato i test, il tuo certificato personale di partecipazione insieme a un bonus una tantum di 40 punti per il club premium.",
      },
    },
  },
  lectures: {
    title: "Formazioni Bridgestone",
    desc: "Amplia la tua competenza e prenota le nostre formazioni e i corsi intensivi per te e il tuo team. Puoi partecipare presso il Bridgestone Competence and Training Center a Dietzenbach (vicino Francoforte sul Meno) oppure, per alcune formazioni, organizzarle direttamente nella tua azienda. Puoi usare i punti bonus per compensare in tutto o in parte i costi.",
    content: "Scopri ora le nostre formazioni attuali e richiedi una prenotazione:",
  },
  singleLecture: {
    registerForm: {
      title: "Contenuti della formazione",
      inquiry: "Richiesta",
      interested: "Sono interessato alla formazione",
      participantsNr: "Numero di partecipanti",
      pointsFromBalance: "Voglio utilizzare punti dal mio saldo.",
      reduction: "Questo corrisponde a una riduzione dei costi di {points} euro.",
      request: "Invia richiesta",
    },
    success: {
      thanks: "Grazie",
      title: "La tua richiesta è stata inviata al team formazione.",
      feedbackTime:
        "Riceverai una risposta entro 14 giorni per chiarire tutti i dettagli.",
      points:
        "I punti bonus utilizzati pari a<br /><strong>{points}</strong> sono stati detratti dal tuo<br />conto punti.",
      refund:
        "Se la formazione non si svolge, i punti ti saranno naturalmente riaccreditati.",
      queries: "Per domande, contatta:",
    },
    index: {
      costs: "Costi e informazioni di partecipazione",
      duration: "Durata: {duration}",
      cost: "Costo {cost}: {price} euro",
      participantsNr: "Partecipanti: min. {min} - max. {max} persone",
    },
  },
  index: {
    title: "Formazione",
    desc: "Il vantaggio è nella conoscenza: ottieni competenze esclusive per te e il tuo team con le nostre offerte formative. Che si tratti delle formazioni online a cui puoi partecipare direttamente sulla piattaforma, dei seminari pratici nel centro di formazione Bridgestone o di formazioni esterne i cui costi puoi ridurre con i tuoi punti premio.",
    online: {
      title: "Formazioni online",
      desc: "Partecipa direttamente sulla piattaforma e ottieni {points} punti per il club premium.",
    },
    lectures: {
      title: "Formazioni",
      desc: "Formazioni di alta qualità nel nostro centro di formazione o presso la tua sede.",
    },
    external: {
      title: "Formazioni esterne",
      desc: "Usa i punti bonus per le offerte di terzi e riduci i costi.",
    },
  },
  single: {
    done: "Formazione completata.",
    doneDownloadCertificate: "Formazione completata. Scarica il certificato.",
  },
  certificate: {
    header: "CERTIFICATO",
    atCourse: "ha partecipato con successo al",
    takePart: "corso.",
    contains: "CONTENUTI DEL CORSO",
    country: "Svizzera",
  },
};

export default {
  messages,
};
